const { createContext } = require('react');

const ThumborContext = createContext({});

module.exports = ThumborContext;
